/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface ActorChangeDayCount
 */
export interface ActorChangeDayCount {
    /**
     * 
     * @type {Date}
     * @memberof ActorChangeDayCount
     */
    date: Date;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ActorChangeDayCount
     */
    count: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the ActorChangeDayCount interface.
 */
export function instanceOfActorChangeDayCount(value: object): value is ActorChangeDayCount {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function ActorChangeDayCountFromJSON(json: any): ActorChangeDayCount {
    return ActorChangeDayCountFromJSONTyped(json, false);
}

export function ActorChangeDayCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActorChangeDayCount {
    if (json == null) {
        return json;
    }
    return {
        
        'date': (new Date(json['date'])),
        'count': ApiUserTasksGetPageParameterFromJSON(json['count']),
    };
}

export function ActorChangeDayCountToJSON(json: any): ActorChangeDayCount {
    return ActorChangeDayCountToJSONTyped(json, false);
}

export function ActorChangeDayCountToJSONTyped(value?: ActorChangeDayCount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'].toISOString().substring(0,10),
        'count': ApiUserTasksGetPageParameterToJSON(value['count']),
    };
}

